import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/onboarding/vendor')({
  // Client-scoped launch (from a client's Vendors tab) carries who to link the new
  // vendor to via `addService` once onboarding completes. Absent = platform-wide
  // launch (no context) — behaves exactly as before.
  validateSearch: (search: Record<string, unknown>): { clientId?: string; clientName?: string } => ({
    clientId: typeof search.clientId === 'string' ? search.clientId : undefined,
    clientName: typeof search.clientName === 'string' ? search.clientName : undefined,
  }),
});
